import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef?.current) {
      observer?.observe(sectionRef?.current);
    }

    return () => observer?.disconnect();
  }, []);

  const faqs = [
    {
      question: 'Как быстро можно начать работу с СФЕРА?',
      answer: 'Базовая настройка занимает 1-2 дня. Мы предоставляем готовые шаблоны для разных отраслей, которые можно адаптировать под ваш бизнес. Полная миграция данных и обучение команды обычно занимает 1-2 недели. Наша команда поддержки сопровождает вас на каждом этапе внедрения.'
    },
    {
      question: 'Можно ли интегрировать СФЕРА с нашими текущими системами?',
      answer: 'Да, СФЕРА имеет готовые интеграции с популярными системами: 1С, Битрикс24, AmoCRM, телефония (Mango, Zadarma), мессенджеры (Telegram, WhatsApp), почтовые сервисы. Также доступен REST API для создания кастомных интеграций с любыми системами. Наши разработчики помогут настроить интеграцию под ваши требования.'
    },
    {
      question: 'Насколько безопасны наши данные в СФЕРА?',
      answer: 'Безопасность данных - наш приоритет. Мы используем шифрование AES-256, имеем сертификаты SOC 2 Type II, ISO 27001, соответствуем требованиям GDPR и ФЗ-152. Данные хранятся в защищенных дата-центрах на территории РФ. Доступны регулярные резервные копии и возможность on-premise развертывания для корпоративных клиентов.'
    },
    {
      question: 'Что включает в себя ИИ-ассистент Виктория?',
      answer: 'Виктория - это умный помощник на базе GPT-4, обученный на специфике вашего бизнеса. Она автоматически обрабатывает входящие заявки, квалифицирует лиды, генерирует коммерческие предложения, создает отчеты, отвечает на типовые вопросы клиентов и предлагает рекомендации по сделкам. Виктория работает 24/7 и постоянно обучается на ваших данных.'
    },
    {
      question: 'Можно ли создавать собственные модули в СФЕРА?',
      answer: 'Да, в тарифах Профессиональный и Корпоративный доступен конструктор модулей. Вы можете создавать кастомные сущности, поля, связи, автоматизации и интерфейсы без программирования. Для сложных задач наша команда разработки создаст индивидуальные модули под ключ. Примеры: учет оборудования, управление проектами, складской учет.'
    },
    {
      question: 'Какая поддержка предоставляется?',
      answer: 'Стартовый план: email поддержка в рабочие часы. Профессиональный: приоритетная поддержка 24/7 через чат, email, телефон. Корпоративный: выделенный менеджер успеха, SLA 99.9%, персональные консультации. Всем клиентам доступна база знаний, видеоуроки и регулярные вебинары по новым функциям.'
    },
    {
      question: 'Есть ли пробный период?',
      answer: 'Да, мы предоставляем 14-дневный бесплатный пробный период с полным доступом ко всем функциям Профессионального тарифа. Не требуется банковская карта для активации. Наша команда поможет настроить систему и обучит ваших сотрудников. После пробного периода вы можете выбрать подходящий тариф или продолжить бесплатно на Стартовом плане с ограничениями.'
    },
    {
      question: 'Как происходит миграция данных из текущей CRM?',
      answer: 'Мы предоставляем бесплатную миграцию данных для всех тарифов. Процесс: 1) Анализ структуры ваших данных, 2) Подготовка шаблонов импорта, 3) Тестовая миграция, 4) Проверка и корректировка, 5) Финальный перенос. Поддерживаем импорт из Excel, CSV, AmoCRM, Битрикс24, Salesforce и других систем. Среднее время миграции: 3-5 дней.'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-card to-background" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl sm:text-5xl font-black text-foreground mb-4">
            Частые вопросы
          </h2>
          <p className="text-xl text-muted-foreground">
            Ответы на самые популярные вопросы о СФЕРА
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className={`glassmorphism-strong rounded-xl overflow-hidden transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-muted/20 transition-colors"
              >
                <span className="text-lg font-bold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={24}
                  color="var(--color-primary)"
                  className="flex-shrink-0"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 animate-fade-in">
                  <p className="text-muted-foreground leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className={`mt-16 text-center transition-all duration-1000 delay-800 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="glassmorphism rounded-2xl p-8">
            <Icon name="MessageCircle" size={48} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-foreground mb-2">
              Не нашли ответ?
            </h3>
            <p className="text-muted-foreground mb-6">
              Наша команда поддержки готова помочь вам 24/7
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:support@sfera-crm.ru"
                className="inline-flex items-center space-x-2 glassmorphism px-6 py-3 rounded-lg hover:bg-muted/20 transition-colors"
              >
                <Icon name="Mail" size={20} color="var(--color-accent)" />
                <span className="text-foreground font-medium">support@sfera-crm.ru</span>
              </a>
              <a
                href="tel:+78001234567"
                className="inline-flex items-center space-x-2 glassmorphism px-6 py-3 rounded-lg hover:bg-muted/20 transition-colors"
              >
                <Icon name="Phone" size={20} color="var(--color-success)" />
                <span className="text-foreground font-medium">8 (800) 123-45-67</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;